import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  id: "yet",
  class: "pb-xl-2 mb-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "subtitle h4 bg-c02 text-white rounded-top-1 p-2 px-3" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-check",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "日時未設定")
], -1)
const _hoisted_3 = { class: "bg-white rounded-bottom-1 p-3 p-sm-4 py-2 py-sm-3" }
const _hoisted_4 = { class: "table-responsive scrollbar pb-3" }
const _hoisted_5 = { class: "table table-bordered h-100" }
const _hoisted_6 = { class: "border-1 fs-small lh-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScheduleLegend = _resolveComponent("ScheduleLegend")!
  const _component_ColGroupByMobile = _resolveComponent("ColGroupByMobile")!
  const _component_ColGroupByPc = _resolveComponent("ColGroupByPc")!
  const _component_TableHead = _resolveComponent("TableHead")!
  const _component_TableData = _resolveComponent("TableData")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ScheduleLegend),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          (_ctx.isMobile)
            ? (_openBlock(), _createBlock(_component_ColGroupByMobile, { key: 0 }))
            : (_openBlock(), _createBlock(_component_ColGroupByPc, { key: 1 })),
          _createVNode(_component_TableHead, { "is-mobile": _ctx.isMobile }, null, 8, ["is-mobile"]),
          _createElementVNode("tbody", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schedules.unset, (unset, key) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: key,
                class: _normalizeClass(unset.statusClass.trClass)
              }, [
                _createVNode(_component_TableData, {
                  schedule: unset,
                  "is-mobile": _ctx.isMobile
                }, null, 8, ["schedule", "is-mobile"])
              ], 2))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}